import { useEffect, useState } from 'react';
import { useSearchParams } from 'react-router-dom';
import { authApi, ApiError } from '../api';
import { useTheme } from '../themes/ThemeContext';

export function EmailVerifyPage() {
  const theme = useTheme();
  const [searchParams] = useSearchParams();
  const token = searchParams.get('token');
  const [status, setStatus] = useState<'loading' | 'success' | 'error'>('loading');
  const [errorMessage, setErrorMessage] = useState('');

  useEffect(() => {
    if (!token) {
      setStatus('error');
      setErrorMessage('No verification token provided.');
      return;
    }

    authApi
      .verifyEmail(token)
      .then(() => setStatus('success'))
      .catch((err) => {
        setStatus('error');
        if (err instanceof ApiError && err.code === 'invalid_token') {
          setErrorMessage('This verification link has expired or is invalid.');
        } else {
          setErrorMessage('An unexpected error occurred. Please try again.');
        }
      });
  }, [token]);

  return (
    <div style={{ background: theme.colors.background, color: theme.colors.text, minHeight: '100vh', display: 'flex', alignItems: 'center', justifyContent: 'center' }}>
      <div style={{ textAlign: 'center', maxWidth: 400, padding: 32 }}>
        {status === 'loading' && <p>Verifying your email...</p>}

        {status === 'success' && (
          <>
            <h1 style={{ fontSize: 24, fontWeight: 600, marginBottom: 16 }}>Email Verified</h1>
            <p>Your email has been verified successfully.</p>
            <a href="/login" style={{ color: theme.colors.primary, marginTop: 16, display: 'inline-block' }}>Log In</a>
          </>
        )}

        {status === 'error' && (
          <>
            <h1 style={{ fontSize: 24, fontWeight: 600, marginBottom: 16, color: '#dc2626' }}>Verification Failed</h1>
            <p>{errorMessage}</p>
            <a href="/login" style={{ color: theme.colors.primary, marginTop: 16, display: 'inline-block' }}>Back to Login</a>
          </>
        )}
      </div>
    </div>
  );
}
